import {Component, Input, OnInit} from '@angular/core';
import {User} from '../../../domain/user';

@Component({
    selector: 'app-user-list-item',
    templateUrl: './user-list-item.component.html',
    styleUrls: ['./user-list-item.component.css'],
    standalone: false
})
export class UserListItemComponent implements OnInit {
  @Input() user: User;

  constructor() {
  }

  ngOnInit(): void {
  }
}
